import WelcomeCard from '@/src/components/home/welcom-card/WelcomeCard'
import HomeTabs from '@/src/components/home/home-tabs/HomeTabs'
import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { authPort, userPreferencesPort } from '@/infra/config/beans'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { usePageHeaders } from '@/src/hooks/use-page-headers/usePageHeaders'
import { Outlet, useNavigate } from 'react-router-dom'
import { useHubNavigation } from '@/src/hooks/use-hub-navigation/useHubNavigation'
import { useQuery } from '@tanstack/react-query'
import { getActions } from '@/infra/api/generated/actions/actions'

const { countActionsToDoByStore } = getActions()
import { useTrackSection } from '@/src/analytics/hooks/use-track-section/useTrackSection'

const Layout = () => {
  const { tab, onTabChange } = useHubNavigation()
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { team, store } = useUserPreferences(userPreferencesPort)
  usePageHeaders(t('pages.home.title'), `${team?.name}`)
  const { data: countActionsToDoResponse } = useQuery({
    queryKey: ['actions', 'count', store?.id],
    enabled: Boolean(store?.id),
    queryFn: () => {
      return countActionsToDoByStore(store!.id)
    },
  })
  const { data: currentUser } = useQuery({
    queryKey: ['profile'],
    queryFn: () => authPort.getUserProfile(),
  })
  useTrackSection()

  return (
    <div className="h-full overflow-auto flex flex-col">
      <WelcomeCard firstName={currentUser?.firstName} />

      <div className="bg-white rounded-t-2xl p-5 flex-1 flex flex-col gap-5">
        <HomeTabs
          value={tab}
          onChange={onTabChange}
          actionsToDoCount={countActionsToDoResponse?.count}
        />
        <div className="h-full flex">
          <Outlet />
        </div>
        {tab === 'diagnosis' && (
          <VpButton
            shape="squared"
            data-testid="start-diag-button"
            className="w-[86%] fixed! bottom-20 text-sm"
            onClick={() => navigate('/diagnoses/new')}
          >
            {t('pages.home.start-diag')}
          </VpButton>
        )}
      </div>
    </div>
  )
}

export default Layout
